import * as tslib_1 from "tslib";
import { GisToolsApi } from '../api/gis-tools-api';
import * as i0 from "@angular/core";
import * as i1 from "../api/gis-tools-api";
var GisToolsService = /** @class */ (function () {
    function GisToolsService(gisToolsApi) {
        this.gisToolsApi = gisToolsApi;
    }
    GisToolsService.prototype.getDistricts = function (ids) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var districts;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getDistricts(ids)];
                    case 1:
                        districts = _a.sent();
                        return [2 /*return*/, this.orderBy(districts, 'districtNumber')];
                }
            });
        });
    };
    GisToolsService.prototype.getCounties = function (ids) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var counties;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getCounties(ids)];
                    case 1:
                        counties = _a.sent();
                        return [2 /*return*/, this.orderBy(counties, 'countyCode')];
                }
            });
        });
    };
    GisToolsService.prototype.getCountiesByDistricts = function (districtNumbers) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var counties;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getCountiesByDistricts(districtNumbers)];
                    case 1:
                        counties = _a.sent();
                        return [2 /*return*/, this.orderBy(counties, 'countyCode')];
                }
            });
        });
    };
    GisToolsService.prototype.getAllDistricts = function (props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var districts;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getAllDistricts(props)];
                    case 1:
                        districts = _a.sent();
                        return [2 /*return*/, this.orderBy(districts, 'districtNumber')];
                }
            });
        });
    };
    GisToolsService.prototype.getAllCounties = function (props, sortProp) {
        if (sortProp === void 0) { sortProp = 'countyCode'; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var counties;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getAllCounties(props)];
                    case 1:
                        counties = _a.sent();
                        return [2 /*return*/, this.orderBy(counties, sortProp)];
                }
            });
        });
    };
    GisToolsService.prototype.getInterstatesByNetworkIndicator = function (networkIndicator, sortProp) {
        if (networkIndicator === void 0) { networkIndicator = 'Y'; }
        if (sortProp === void 0) { sortProp = 'stateRouteNumber'; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var interstates;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getInterstatesByNetworkIndicator([networkIndicator])];
                    case 1:
                        interstates = _a.sent();
                        return [2 /*return*/, this.orderBy(interstates, sortProp)];
                }
            });
        });
    };
    GisToolsService.prototype.getMunicipalitiesByCounty = function (countyCode, props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var municipalities;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getMunicipalitiesByCounty(countyCode, props)];
                    case 1:
                        municipalities = _a.sent();
                        return [2 /*return*/, this.orderBy(municipalities, 'municipalityCode')];
                }
            });
        });
    };
    GisToolsService.prototype.getAllMunicipalities = function (props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var municipalities;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getAllMunicipalities(props)];
                    case 1:
                        municipalities = _a.sent();
                        return [2 /*return*/, this.orderBy(municipalities, 'municipalityCode')];
                }
            });
        });
    };
    GisToolsService.prototype.getAllSchoolDistricts = function (props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var schoolDistricts;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getAllSchoolDistricts(props)];
                    case 1:
                        schoolDistricts = _a.sent();
                        return [2 /*return*/, this.orderBy(schoolDistricts, 'schoolDistrictName')];
                }
            });
        });
    };
    GisToolsService.prototype.getAllZipCodes = function (props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var zipCodes;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getAllZipCodes(props)];
                    case 1:
                        zipCodes = _a.sent();
                        return [2 /*return*/, this.orderBy(zipCodes, 'zip')];
                }
            });
        });
    };
    GisToolsService.prototype.getAllPlanningPartners = function (props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var planningPartners;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getAllPlanningPartners(props)];
                    case 1:
                        planningPartners = _a.sent();
                        return [2 /*return*/, this.orderBy(planningPartners, 'planningPartnerShortName')];
                }
            });
        });
    };
    GisToolsService.prototype.getAllHouseDistricts = function (props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var houseDistricts;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getAllHouseDistricts(props)];
                    case 1:
                        houseDistricts = _a.sent();
                        houseDistricts.forEach(function (h) { return h.houseDistrictNumber = h.legislativeDistrictNumber; });
                        return [2 /*return*/, this.orderBy(houseDistricts, 'legislativeDistrictNumber')];
                }
            });
        });
    };
    GisToolsService.prototype.getAllSenateDistricts = function (props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var senateDistricts;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getAllSenateDistricts(props)];
                    case 1:
                        senateDistricts = _a.sent();
                        senateDistricts.forEach(function (s) { return s.senateDistrictNumber = s.legislativeDistrictNumber; });
                        return [2 /*return*/, this.orderBy(senateDistricts, 'legislativeDistrictNumber')];
                }
            });
        });
    };
    GisToolsService.prototype.getAllCongressionalDistricts = function (props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var congressionalDistricts;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getAllCongressionalDistricts(props)];
                    case 1:
                        congressionalDistricts = _a.sent();
                        congressionalDistricts.forEach(function (s) { return s.congressionalDistrictNumber = s.legislativeDistrictNumber; });
                        return [2 /*return*/, this.orderBy(congressionalDistricts, 'legislativeDistrictNumber')];
                }
            });
        });
    };
    GisToolsService.prototype.getAllStateRoutes = function (props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var stateRoutes;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getAllStateRoutes(props)];
                    case 1:
                        stateRoutes = _a.sent();
                        return [2 /*return*/, this.orderBy(stateRoutes, 'stateRouteNumber')];
                }
            });
        });
    };
    GisToolsService.prototype.getStateRoutesByCounty = function (countyCode, props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var stateRoutes;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getStateRoutesByCounty(countyCode, props)];
                    case 1:
                        stateRoutes = _a.sent();
                        return [2 /*return*/, this.orderBy(stateRoutes, 'stateRouteNumber')];
                }
            });
        });
    };
    GisToolsService.prototype.getStateRoutesByCountyAndJuris = function (countyCode, juris, props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var stateRoutes;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getStateRoutesByCountyJuris(countyCode, juris, props)];
                    case 1:
                        stateRoutes = _a.sent();
                        return [2 /*return*/, this.orderBy(stateRoutes, 'stateRouteNumber')];
                }
            });
        });
    };
    GisToolsService.prototype.getStateRoutesByCountyJuris = function (countyCode, jurisValues, props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var stateRoutes;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getStateRoutesByCountyJuris(countyCode, jurisValues, props)];
                    case 1:
                        stateRoutes = _a.sent();
                        return [2 /*return*/, this.orderBy(stateRoutes, 'stateRouteNumber')];
                }
            });
        });
    };
    GisToolsService.prototype.getAllSegments = function (props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var segments;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getAllSegments(props)];
                    case 1:
                        segments = _a.sent();
                        return [2 /*return*/, this.orderBy(segments, 'segmentNumber')];
                }
            });
        });
    };
    GisToolsService.prototype.getSegmentsByCountyAndRoute = function (countyCode, routeNumber, props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var segments;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getSegmentsByCountyAndRoute(countyCode, routeNumber, props)];
                    case 1:
                        segments = _a.sent();
                        return [2 /*return*/, this.orderBy(segments, 'segmentNumber')];
                }
            });
        });
    };
    GisToolsService.prototype.getSegmentsNearLatLong = function (latitude, longitude, tolerance) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var segments;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getSegmentsNearLatLong(latitude, longitude, tolerance)];
                    case 1:
                        segments = _a.sent();
                        return [2 /*return*/, segments];
                }
            });
        });
    };
    GisToolsService.prototype.getOffsetForCRSLatLong = function (lat, long, county, route, buffer, props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var segments;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!props.includes('distance')) {
                            props = tslib_1.__spread(props.split(','), ['distance']).join(',');
                        }
                        return [4 /*yield*/, this.gisToolsApi.getOffsetForCRSLatLong(lat, long, county, route, buffer, props)];
                    case 1:
                        segments = _a.sent();
                        return [2 /*return*/, this.orderBy(segments, 'distance')];
                }
            });
        });
    };
    GisToolsService.prototype.getAllColumnIdentifiers = function (props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.gisToolsApi.getAllColumnIdentifiers(props)];
            });
        });
    };
    GisToolsService.prototype.getColumns = function (layerId, props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getColumns(layerId, props)];
                    case 1:
                        result = _a.sent();
                        if (result.length > 0) {
                            return [2 /*return*/, result[0].columns];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    GisToolsService.prototype.getOffsetForLatLong = function (lat, long, buffer, props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getOffsetForLatLong(lat, long, buffer, props)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsService.prototype.getNearbyLocalIntersections = function (lat, long, buffer, props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getNearbyLocalIntersections(lat, long, buffer, props)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsService.prototype.getLatLongForOffset = function (countyCode, stateRouteNumber, segmentNumber, offset) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getLatLongForOffset(countyCode, stateRouteNumber, segmentNumber, offset)];
                    case 1:
                        result = _a.sent();
                        if (result && result[0]) {
                            return [2 /*return*/, result[0].latLong];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    GisToolsService.prototype.getFeaturesByObjectId = function (pluralObjectName, props, objectIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getFeaturesByObjectId(pluralObjectName, props, objectIds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsService.prototype.getRailCrossing = function (crossingId, props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getRailCrossing(crossingId, props)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result && result.length === 1 ? result[0] : null];
                }
            });
        });
    };
    GisToolsService.prototype.orderBy = function (arr, prop) {
        if (!arr) {
            return arr;
        }
        return arr.sort(function (a, b) { return (a[prop] > b[prop]) ? 1 : ((b[prop] > a[prop]) ? -1 : 0); });
    };
    GisToolsService.ngInjectableDef = i0.defineInjectable({ factory: function GisToolsService_Factory() { return new GisToolsService(i0.inject(i1.GisToolsApi)); }, token: GisToolsService, providedIn: "root" });
    return GisToolsService;
}());
export { GisToolsService };
